import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";

import ActionRequiredImage from "../../Images/ActionRequiredImage.svg";

function AccountActivationMyPlan(props) {
  document.title = "myPlan | Account Activation";
  const environment = props.environment;
  const history = useHistory();
  const [success, setSuccess] = useState(false);
  const [resultFlag, setResultFlag] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (
      queryString.parse(window.location.search).ak === undefined ||
      queryString.parse(window.location.search).ak === ""
    ) {
      history.push("myPlan/login");
    }
    fetch(environment.myPlanLoginAppAPI + Constants.accountActivation, {
      method: "POST",
      body: JSON.stringify({
        accountData: {
          ak: queryString.parse(window.location.search).ak,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setSuccess(true);
          setResultFlag(result.dataStatus.isSuccess);
          setMsg(result.dataStatus.message);
        },
        (error) => {
          console.log(error);
        }
      );
  }, [history, environment]);

  return (
    <div
      className={`${
        success ? "App col-12 d-flex align-items-center myPlan" : ""
      }`}
    >
      {!success && (
        <div className="page-spinner-bar">
          <div
            role="status"
            className="spinner-grow spinner-grow-sm text-primary"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <div
            role="status"
            className="spinner-grow spinner-grow-sm text-secondary"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <div
            role="status"
            className="spinner-grow spinner-grow-sm text-success"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <div
            role="status"
            className="spinner-grow spinner-grow-sm text-danger"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
      {success && (
        <div className="container custom-container">
          <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
            <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
              <div className="d-flex flex-column margin-interaction-card">
                <div className="font-20-600 text-align-left">
                  Account Activation
                </div>
                <Description
                  className="description"
                  text="Use a unique password to keep your account secure"
                ></Description>
                <img
                  src={ActionRequiredImage}
                  alt=""
                  className="forget-password-image mt-3"
                />
                <div className="padding-top d-block">
                  <HighlightText
                    className="grey text-align-left font-12-400 center-on-medium-devices"
                    subClassName="blue underline"
                    text1="Need Help ? We are just a click away"
                    text2=""
                    subText="Contact us"
                    hasHyperLink={true}
                    hyperLink="https://www.zetran.com/contact-us/"
                  ></HighlightText>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
              <div className="mx-auto margin-interaction-card interaction-card">
                <div className="d-flex flex-wrap justify-content-center pb-lg-3">
                  <img
                    src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myPlan_logo_Black.png"
                    alt=""
                    className="logo-image"
                  />
                </div>
                <div class="font-20-600 d-lg-none b-block my-3">
                  Account Activation
                </div>
                <div className="min-height-250px my-5 my-lg-0">
                  <h2 className="font-20-600 text-lg-center">
                    {resultFlag &&
                      "Your account has been activated. Enjoy using myPlan :)"}
                    {!resultFlag && msg}
                  </h2>
                  <p className="poppins-14 Color-9C9C9C pt-2 text-left font-18">
                    {resultFlag && msg}
                    {!resultFlag &&
                      "Try login (or) Ensure that you have clicked on the correct verification link."}
                  </p>
                </div>
                <button
                  className="button d-flex flex-wrap align-items-center justify-content-center"
                  onClick={() => {
                    if (resultFlag) {
                      history.push("/myPlan/login");
                    } else {
                      history.push("/myPlan/signup");
                    }
                  }}
                >
                  <>
                    <div className="mr-2">
                      {resultFlag && "Start using myPlan"}
                      {!resultFlag && "Register with myPlan"}
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccountActivationMyPlan;
